"use client"

import { useState, useEffect } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ExchangeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.accent};
`

const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
`

const RatioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const RatioItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const RatioHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
`

const RatioLabel = styled.span`
  color: ${(props) => (props.type === "long" ? props.theme.success : props.theme.error)};
`

const RatioValue = styled.span`
  font-weight: 500;
`

const ProgressBar = styled.div`
  height: 8px;
  background-color: ${(props) => props.theme.secondary};
  border-radius: 9999px;
  overflow: hidden;
`

const ProgressIndicator = styled.div`
  height: 100%;
  width: ${(props) => props.value}%;
  background-color: ${(props) => (props.type === "long" ? props.theme.success : props.theme.error)};
`

function LongShortRatio() {
  const [ratios, setRatios] = useState({
    longRatio: 65,
    shortRatio: 35,
    topTraderLongRatio: 58,
    topTraderShortRatio: 42,
  })

  // Simulate fetching data
  useEffect(() => {
    // This would be replaced with actual API calls
    const interval = setInterval(() => {
      // Simulate small changes to the ratios
      setRatios((prev) => {
        const longRatio = Math.min(Math.max(prev.longRatio + (Math.random() * 2 - 1), 30), 70)
        const topTraderLongRatio = Math.min(Math.max(prev.topTraderLongRatio + (Math.random() * 2 - 1), 40), 60)

        return {
          longRatio,
          shortRatio: 100 - longRatio,
          topTraderLongRatio,
          topTraderShortRatio: 100 - topTraderLongRatio,
        }
      })
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return (
    <Container>
      <Section>
        <SectionHeader>
          <ExchangeIcon />
          <SectionTitle>Long/Short Ratio</SectionTitle>
        </SectionHeader>

        <RatioContainer>
          <RatioItem>
            <RatioHeader>
              <RatioLabel type="long">LONG (Buy) Ratio</RatioLabel>
              <RatioValue>{ratios.longRatio.toFixed(1)}%</RatioValue>
            </RatioHeader>
            <ProgressBar>
              <ProgressIndicator type="long" value={ratios.longRatio} />
            </ProgressBar>
          </RatioItem>

          <RatioItem>
            <RatioHeader>
              <RatioLabel type="short">SHORT (Sell) Ratio</RatioLabel>
              <RatioValue>{ratios.shortRatio.toFixed(1)}%</RatioValue>
            </RatioHeader>
            <ProgressBar>
              <ProgressIndicator type="short" value={ratios.shortRatio} />
            </ProgressBar>
          </RatioItem>
        </RatioContainer>
      </Section>

      <Section>
        <SectionHeader>
          <ExchangeIcon />
          <SectionTitle>Top Trader Long/Short Ratio</SectionTitle>
        </SectionHeader>

        <RatioContainer>
          <RatioItem>
            <RatioHeader>
              <RatioLabel type="long">LONG (Buy) Ratio</RatioLabel>
              <RatioValue>{ratios.topTraderLongRatio.toFixed(1)}%</RatioValue>
            </RatioHeader>
            <ProgressBar>
              <ProgressIndicator type="long" value={ratios.topTraderLongRatio} />
            </ProgressBar>
          </RatioItem>

          <RatioItem>
            <RatioHeader>
              <RatioLabel type="short">SHORT (Sell) Ratio</RatioLabel>
              <RatioValue>{ratios.topTraderShortRatio.toFixed(1)}%</RatioValue>
            </RatioHeader>
            <ProgressBar>
              <ProgressIndicator type="short" value={ratios.topTraderShortRatio} />
            </ProgressBar>
          </RatioItem>
        </RatioContainer>
      </Section>
    </Container>
  )
}

export default LongShortRatio

